export default __webpack_public_path__ + "static/media/owl-1.c797b3cb.png";